import * as tslib_1 from "tslib";
import * as React from 'react';
import { GaugeViewChart, IconViewChart, ScaleViewChart, ValueViewChart } from '../ViewCharts';
import Styles from "./ViewChart.css";

var ViewChart =
/** @class */
function (_super) {
  tslib_1.__extends(ViewChart, _super);

  function ViewChart() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ViewChart.prototype.render = function () {
    var _a = this.props,
        viewCharts = _a.viewCharts,
        type = _a.type,
        other = tslib_1.__rest(_a, ["viewCharts", "type"]);

    var ViewChartComponent = viewCharts[type];
    return React.createElement("div", {
      className: Styles.viewChart
    }, React.createElement(ViewChartComponent, tslib_1.__assign({}, other)));
  };

  ViewChart.defaultProps = {
    viewCharts: {
      gauge: GaugeViewChart,
      icon: IconViewChart,
      scale: ScaleViewChart,
      value: ValueViewChart
    }
  };
  return ViewChart;
}(React.PureComponent);

export default ViewChart;